<div class="needs-update-in-crm" *ngIf="!hasValue">
  <mat-icon>error_outline</mat-icon>
  <span>Update this field in the CRM</span>
</div>

<ng-content *ngIf="hasValue"></ng-content>
